export enum LicenseUsageColor {
    ALMOST_FULL = "danger",
    ABOVE_HALF = "warning",
    BELOW_HALF = "primary"
};